import { get } from 'lodash';
import services from 'services';

const RESPONDER_V2_URL = '/tb/api/v2/authenticated/responder';

class ResponderV2Service {
  saveResponder(body) {
    return services.post(`${RESPONDER_V2_URL}/save`, body);
  }

  searchResponder(
    body = {
      published: true,
      page: 0,
      size: 10,
      status: true,
      title: '',
      contactGroupId: 1,
      didGroupId: 2,
    }
  ) {
    return services.post(`${RESPONDER_V2_URL}/search`, body);
  }

  deleteResponder({ id }) {
    return services.delete(`${RESPONDER_V2_URL}/delete?id=${id}`);
  }

  getConfig() {
    return services.get(`${RESPONDER_V2_URL}/config`);
  }

  getNodes({ responderId }) {
    return services.post(`${RESPONDER_V2_URL}/getNodes?responderId=${responderId}`);
  }

  saveNode(body) {
    return services.post(`${RESPONDER_V2_URL}/saveNode`, body);
  }

  deleteNode({ responderId, nodeId }) {
    return services.delete(
      `${RESPONDER_V2_URL}/deleteNode?responderId=${responderId}&id=${nodeId}`
    );
  }

  publishTemplate({ title, templateId }) {
    return services.post(`${RESPONDER_V2_URL}/publish?title=${title}&templateId=${templateId}`);
  }

  duplicateTemplate({ title, templateId }) {
    return services.post(`${RESPONDER_V2_URL}/duplicate`, {
      title,
      templateId,
    });
  }

  simulateAction(body = { responderTriggerId: '' }, configs) {
    return services.post(`${RESPONDER_V2_URL}/simulateAction`, body, configs);
  }

  createAIAssisstantSetting(
    body = {
      category: '',
      goal: '',
      target: '',
      bannedWords: '',
      knowledgeBaseFiles: [],
      instructions: '',
      winningCreative: '',
    },
    configs
  ) {
    const formData = new FormData();

    [
      'category',
      'goal',
      'target',
      'bannedWords',
      'instructions',
      'winningCreative',
      'maxCharCount',
    ].forEach((key) => {
      formData.append(key, get(body, key) || '');
    });

    if (body?.knowledgeBaseMap) {
      formData.append('knowledgeBaseMapStr', JSON.stringify(body?.knowledgeBaseMap));
    }

    for (let file of body?.knowledgeBaseFiles || []) {
      formData.append('knowledgeBaseFiles', file);
    }

    return services.post(`${RESPONDER_V2_URL}/aiAssistantSetting`, formData, configs);
  }

  createAIAssisstantDemo(
    body = {
      category: '',
      goal: '',
      target: '',
      bannedWords: '',
      knowledgeBaseFiles: [],
      instructions: '',
      winningCreative: '',
    },
    configs
  ) {
    const formData = new FormData();

    [
      'category',
      'goal',
      'target',
      'bannedWords',
      'instructions',
      'winningCreative',
      'maxCharCount',
    ].forEach((key) => {
      formData.append(key, get(body, key) || '');
    });

    if (body?.knowledgeBaseMap) {
      formData.append('knowledgeBaseMapStr', JSON.stringify(body?.knowledgeBaseMap));
    }

    for (let file of body?.knowledgeBaseFiles || []) {
      formData.append('knowledgeBaseFiles', file);
    }

    return services.post(`${RESPONDER_V2_URL}/aiAssistantSetting/demo`, formData, configs);
  }

  paidActionStats(body = { responderId: '' }, configs) {
    return services.post(
      `${RESPONDER_V2_URL}/paidActionStats?responderId=${body?.responderId}`,
      {},
      configs
    );
  }
}

export default new ResponderV2Service();
